import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClassificationFuelingChartComponent } from './classification-fueling-chart.component';

@NgModule({
  declarations: [
    ClassificationFuelingChartComponent // Declare the component here
  ],
  imports: [
    CommonModule // Import CommonModule for common directives
  ],
  exports: [
    ClassificationFuelingChartComponent // Export the component so it can be used in other modules
  ]
})
export class ClassificationFuelingChartModule { }
